export class Model {
    constructor(public id:number,public name:string,public price:number){
        this.id = id;
        this.name = name;
        this.price = price;
    }
}
